import { axiosInstance } from '@/lib/axios';
import type { ExtractionSampleRequest, ExtractionSampleResponse } from '@/types/api.types';

/**
 * Extraction Sample Service
 * Handles permit extraction sample submission API calls (admin only)
 */

/**
 * Submit extraction sample
 * Admin endpoint - authentication required
 */
export const submitExtractionSample = async (
  formData: ExtractionSampleRequest
): Promise<ExtractionSampleResponse> => {
  const response = await axiosInstance.post<ExtractionSampleResponse>(
    '/extraction-sample/submit',
    formData
  );

  return response.data;
};
